import * as React from 'react';
import { IconProps } from '../types';

const IcPaymentTypeCreditCard = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M21.929 8.857H3.072v1.572h18.857V8.857Zm0 3.143H3.072v4.614c0 1.04.06 1.357.234 1.681.121.232.311.421.543.542.323.173.64.234 1.68.234h13.942c1.04 0 1.358-.06 1.681-.234.232-.122.421-.311.543-.543.172-.323.234-.64.234-1.68V12Zm-.234-6.295c.167.313.23.62.233 1.58H3.072c.004-.96.067-1.267.234-1.579.12-.232.31-.421.542-.543.324-.173.641-.234 1.681-.234h13.942c1.04 0 1.358.06 1.68.234.232.12.422.31.544.542Zm1.803 1.58c-.007-1.324-.152-1.822-.42-2.322a2.843 2.843 0 0 0-1.189-1.188c-.51-.273-1.018-.42-2.42-.42H5.526c-1.398 0-1.908.147-2.42.42a2.843 2.843 0 0 0-1.188 1.19c-.273.51-.42 1.018-.42 2.42v9.23c0 1.399.147 1.908.42 2.42.268.507.683.92 1.19 1.188.51.274 1.018.42 2.42.42h13.944c1.399 0 1.908-.146 2.42-.42a2.845 2.845 0 0 0 1.189-1.19c.273-.51.419-1.018.419-2.42V7.287h-.002Zm-12.57 7.858H4.644v1.571h6.286v-1.571Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IcPaymentTypeCreditCard;
